import { render, staticRenderFns } from "./Fundraising.vue?vue&type=template&id=849b4964"
import script from "./Fundraising.vue?vue&type=script&lang=js"
export * from "./Fundraising.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports